import { AccountCircle, LogoutOutlined, Person } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../context/Login/LoginContext";
import PopupMenu from "../../PopupMenu/PopupMenu";
import UserImage from "../../UserImage";
import { HeaderIconButton } from "./Components";

const LoginButton = () => {
    const navigate = useNavigate();
    const { isLoggedIn, logout, user, openLoginDialog } = useLogin();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    useEffect(() => {
        setAnchorEl(null);
    }, [isLoggedIn]);

    if (!isLoggedIn)
        return (
            <HeaderIconButton onClick={openLoginDialog}>
                <AccountCircle />
            </HeaderIconButton>
        )

    return (
        <>
            <HeaderIconButton
                onClick={(e) => setAnchorEl(e.currentTarget)}
                onContextMenu={(e) => {
                    e.preventDefault();
                    setAnchorEl(e.currentTarget)
                }}
            >
                <UserImage image={user?.image} size={32} name={user?.fullName || user?.email} />
            </HeaderIconButton>
            <PopupMenu
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                options={[
                    { label: 'Profile', onClick: () => navigate('/profile'), icon: <Person /> },
                    { label: 'Logout', onClick: () => logout(), icon: <LogoutOutlined /> },
                ]}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                offsetY={1}
            />
        </>
    )
}


export default LoginButton;